export const ellipsizeFileName = (name = '', max = 42) => {
  const safe = String(name || '');
  if (safe.length <= max) return safe;

  const lastDot = safe.lastIndexOf('.');
  const hasExt = lastDot > 0 && lastDot < safe.length - 1;
  const ext = hasExt ? safe.slice(lastDot) : '';
  const base = hasExt ? safe.slice(0, lastDot) : safe;

  const ellipsis = '…';
  const room = max - ellipsis.length - ext.length;
  if (room <= 0) return safe.slice(0, max - ellipsis.length) + ellipsis;

  return base.slice(0, room) + ellipsis + ext;
};
